export const isNetworkError = (error: unknown): boolean => {
    if (error instanceof TypeError) {
        const msg = error.message.toLocaleLowerCase();

        const isForOneOfTheBrowsers =
            msg.startsWith("failed to fetch") || // chrome, edge
            msg.startsWith("network error") || // firefox
            msg.startsWith("networkerror") || // firefox
            msg.startsWith("load failed"); // safari

        return isForOneOfTheBrowsers;
    }

    if (error instanceof DOMException) {
        return error.name === "NetworkError";
    }

    return false;
};

export const isAbortError = (error: unknown): boolean => {
    if (!(error instanceof DOMException)) {
        return false;
    }

    const msg = error.message.toLocaleLowerCase();

    return (
        error.name === "AbortError" ||
        msg.startsWith("the operation was aborted") ||
        msg.startsWith("the user aborted a request")
    );
};
